import {RemoteGetAuthCities} from 'data/usecases/private/authorizations';
import {GetAuthCities} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {AuthorizationsFlowEndpoints} from '../../endpoints';

export const makeGetAuthCities = (): GetAuthCities =>
	new RemoteGetAuthCities(
		makeBFFApiUrl(AuthorizationsFlowEndpoints.cities),
		makeAuthorizeHttpClientDecorator(),
	);
